<script setup>
  import {inject, watch} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {useForm} from "@inertiajs/vue3";
  import {MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentContactCardFavorite",
  });

  const props = defineProps({
    patient: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  });

  const broadcast = inject("$broadcast");

  const form = useForm({
    favorite: props.contact?.favorite ?? false,
  });

  watch(
    () => props.contact.favorite,
    (newValue) => {
      form.favorite = newValue;
    },
  );

  function toggle() {
    form.favorite = !form.favorite;

    form.patch(route("assignment.update", {patient: props.patient.id, contact: props.contact.id}), {
      preserveScroll: true,
      preserveState: true,
      optimistic: (pageProperties) => {
        if (!pageProperties.patient?.contacts) return {};

        return {
          patient: {
            ...pageProperties.patient,
            contacts: pageProperties.patient.contacts.map((c) =>
              c.id === props.contact.id ? {...c, favorite: form.favorite} : c,
            ),
          },
        };
      },
      onError: () => {
        form.favorite = props.contact.favorite;
      },
      onSuccess: () => {
        broadcast.patient.postMessage(props.patient.id, {action: "reload.patient"});
      },
      only: ["flash", "errors", "patient"],
    });
  }
</script>

<template>
  <button
    class="absolute -top-0.5 right-2 enabled:cursor-pointer"
    :data-test="getTestId('add-favorite')"
    @click.prevent="toggle"
  >
    <MedTooltip :content="form.favorite ? 'Favorit für Patienten' : 'als Favorit festlegen'">
      <ComponentIcon v-if="form.favorite" class="inline-block text-2xl text-mcred hover:text-gray-500">
        bookmark
      </ComponentIcon>

      <ComponentIcon v-else class="inline-block text-2xl text-gray-500 hover:text-mcred">bookmark_border</ComponentIcon>
    </MedTooltip>
  </button>
</template>
